import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { EffectsModule } from '@ngrx/effects';

import { AnalyticsDirectivesModule } from '@analytics/events';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';

import { GenericLightboxEffects } from './+state/generic-lightbox.effects';
import { GenericLightboxComponent } from './generic-lightbox.component';

const EFFECTS = [GenericLightboxEffects];

@NgModule({
  imports: [
    CommonModule,
    JssModule,
    CommonUiUtilityComponentsModule,
    AnalyticsDirectivesModule,
    EffectsModule.forFeature(EFFECTS),
    ModalComponent,
    ModalBodyDirective,
    GenericLightboxComponent,
  ],
})
export class GenericLightboxModule {}
